import { useCallback } from 'react'

import { fireInteractionEvent } from 'api/googleTagManager'
import { calendarAction } from 'analytics/eventDefinitions'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'

import { CALENDAR_GA_EVENT_LABEL, CALENDAR_GA_EVENT_ACTION } from 'constants/analytics'
import { OFFER_TYPE_BED_BANK_ANALYTICS } from 'constants/offer'

function useBedbankSelectDates() {
  const offerPageDispatch = useOfferPageDispatch()

  const onCalendarOpenSelectDates = useCallback(() => {
    fireInteractionEvent(calendarAction(
      OFFER_TYPE_BED_BANK_ANALYTICS,
      CALENDAR_GA_EVENT_ACTION.OpenFilter,
      CALENDAR_GA_EVENT_LABEL.PackageOptionDate))
    offerPageDispatch({ type: OfferPageActions.toggleFilter, filter: 'datepicker' })
  }, [offerPageDispatch])

  return onCalendarOpenSelectDates
}

export default useBedbankSelectDates
